import { Component } from 'react';

import { BpkSpinner } from '@skyscanner/backpack-web/bpk-component-spinner';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { BackgroundImageProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './BackgroundImage.module.scss';

const getClassName = cssModules(STYLES);

class BackgroundImage extends Component<BackgroundImageProps> {
  trackImage: HTMLImageElement | null;

  constructor(props: BackgroundImageProps) {
    super(props);

    this.trackImage = null;
  }

  componentDidMount() {
    if (this.props.inView) {
      this.startImageLoad();
    }
  }

  componentDidUpdate(prevProps: BackgroundImageProps) {
    if (this.props.inView && !prevProps.inView) {
      this.startImageLoad();
    }
  }

  onBackgroundImageLoad = () => {
    if (this.props.onLoad) {
      this.props.onLoad();
    }

    Reflect.deleteProperty(this, 'trackImage');
  };

  startImageLoad = () => {
    this.trackImage = new Image();
    this.trackImage.src = this.props.src;
    this.trackImage.onload = this.onBackgroundImageLoad;
  };

  render() {
    const {
      children = null,
      imageClassName = null,
      imageStyle = null,
      inView = true,
      loading = false,
      src,
    } = this.props;

    const spinnerClassNames = [getClassName('BackgroundImage__spinner')];
    const contentClassNames = [
      getClassName('BackgroundImage__content'),
      getClassName('BackgroundImage__imageContainer'),
    ];

    if (!loading) {
      spinnerClassNames.push(getClassName('BackgroundImage__spinner--hide'));
      contentClassNames.push(getClassName('BackgroundImage__content--show'));
    }

    if (imageClassName) {
      contentClassNames.push(imageClassName);
    }

    const contentClassNamesNoScript = [
      getClassName('BackgroundImage__content'),
      getClassName('BackgroundImage__content--show'),
    ];

    return (
      <>
        <div className={spinnerClassNames.join(' ')}>
          <BpkSpinner />
        </div>
        <div
          className={contentClassNames.join(' ')}
          style={{
            backgroundImage: !inView || loading ? '' : `url(${src})`,
            ...imageStyle,
          }}
        >
          {!loading && children}
        </div>
        {typeof window === 'undefined' && (!inView || loading) && (
          <noscript>
            <div
              className={contentClassNamesNoScript.join(' ')}
              style={{ backgroundImage: `url(${src})`, ...imageStyle }}
            >
              {children}
            </div>
          </noscript>
        )}
      </>
    );
  }
}

export default BackgroundImage;
